import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useContext } from 'react';
import RenderTime from './RenderTime';
export default function useRenderTime() {
  var updateOnMount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var getTimeState = useContext(RenderTime.Context);

  var _getTimeState = getTimeState(),
      _getTimeState2 = _slicedToArray(_getTimeState, 2),
      getTime = _getTimeState2[0],
      isInitial = _getTimeState2[1];

  var _useState = useState(!isInitial),
      _useState2 = _slicedToArray(_useState, 2),
      upToDate = _useState2[0],
      setUpToDate = _useState2[1];

  useEffect(function () {
    if (!upToDate && updateOnMount) {
      setUpToDate(true);
    }
  }, [upToDate, updateOnMount]);
  return getTime;
}